export default __webpack_public_path__ + "static/media/pcard3.2db0b792.webp";